import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ServiceResponse } from 'src/app/models/service-response';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { NewactionService } from 'src/app/rest_services/newaction.service';
import { TeamService } from 'src/app/rest_services/team.service';
import { VisitService } from 'src/app/rest_services/visit.service';
import { clients } from './visite_data_static';
import { Router } from '@angular/router';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { phoneNumberValidator } from 'src/app/validators/phone-number.validator';


// MF-1881 — borne haute du nombre de sujets par visite, imposée côté back aussi.
const MAX_TOPICS = 5;

@Component({
  selector: 'app-new-visit',
  templateUrl: './new-visit.component.html',
  styleUrls: ['./new-visit.component.css']
})
export class NewVisitComponent implements OnInit, OnDestroy{
  newactionRequest:any;
  //Commercial to affect vars
  loadingCommercials:boolean=true;
  ourTeam:any[]= [];
  publicActions:any[]=[];
  customizedActions:any[]=[];
  htmlYouWantToAdd:any="";
  actionsSelected:any[]=[];
  refSectors:any[]=[];
  refClients:any[]=clients;
  clientsOfSector:any[]=[];
  citiesClient:any[]=[];
  sitesOfCity:any[]=[];
  newactionForm!: FormGroup;
  loadingCustomers:boolean=false;
  newVisitRequest:any;
  newVisitForm!: FormGroup;
  agent:any="- - -";address:any="- - -";
  actionNotAssigned:boolean= false;
  customer:any;
  actionEdit:any={};
  ActionFormValue:any;action:any;
  error_new_visit:boolean=false;
  loadingCustomizedActions:boolean =false;
  loadingAddingVisit:boolean=false;
  agentNotified:any;
  type_creation:any;
  cities:any[]=[];
  // add customer
  newCustomerForm!:FormGroup;
  refCities:any[]=[];
  role:any=null;
  loadingAddingCustomer:boolean=false;
  newCustomerRequest:any={};
  addError: string="";

  commercials:any[]=[];
  commercialsSubscriptions!: Subscription;
  dc!: boolean;
  token : any = '';
  
  constructor(private fb: FormBuilder,
     private visitService:VisitService,
     private teamService: TeamService,
     private router :Router,
    private msSector : MsSectorService,
     private newactionServiceService:NewactionService,
     private customersService :CustomersService) {
      this.Topic();
      this.initForms();
  }
  mobile:boolean=false;
  ngOnInit(): void {
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    this.getAllCustomers();
    this.loadingCommercials=true;
    var glob = this;
    // var el:any =  $('#allClassesSuggestions');
    // el.modal('show');

    // $("#clientSelect").prop("disabled", true);
    $("#citiesSelect").prop("disabled", true);
    var blocActions = this.htmlYouWantToAdd;
    $('#actionselect').change(function(){ 
      var value = $(this).val();
      var elt = glob.customizedActions.find(el => el.action_uuid == value);
      var uuid = $("option:selected", this).attr("ud");
      var action = {
        action_description : $( "#actionselect option:selected" ).text(),
        action_type : "c",
        action_uuid : uuid
      }
      let index = glob.actionsSelected.findIndex(d => d.action_description == elt.action_label);      
      if(index<0){
        glob.actionsSelected.push(action);
        setTimeout(()=>{
          $('#actionselect').val("")
        }, 500);
      }
      if(glob.actionsSelected.length>0){
        glob.actionNotAssigned = false;
      }else {
        if($('#datePlanned').val() != "" && $('#datePlanned').val() != null){
          glob.actionNotAssigned = true;
          $("#noActionsSelected").css({"color":"red"});
        }else {
          glob.actionNotAssigned = false;
        }
      }
    });
    $('#sectorsSelect').change(function(){ 
      var value = $(this).val();
      glob.agent = "- - -";
      glob.address = "- - -";
      glob.loadingCustomers =true;
      $("#citiesSelect").prop("disabled", true);
      if(value){
        glob.getCustomers(value);
      } else {
        glob.getAllCustomers();
      }
      glob.newVisitForm.controls['customer_uuid'].setValue("", {onlySelf: true});

    });
    
    $('#datePlanned').change(function(){ 
      var value = $(this).val();
      if(value=="" || value==null){
        if(glob.actionsSelected.length>0){
          glob.actionNotAssigned = false;
        }
      }else {
        if(glob.actionsSelected.length==0){
          $("#noActionsSelected").css({"color":"red"});
          glob.actionNotAssigned = true;
        }
      }
    });
    
    $('#clientSelect').change(function(){ 
      $("#citiesSelect").prop("disabled", false);
      var value = $(this).val();      
      if(value==null || value==""){
        glob.newVisitForm.controls['city_uuid'].setValue("", {onlySelf: true});
      }
      var city=null;
      glob.agent = "- - -";
      glob.address = "- - -";
      var cities = [];
      var selectedelement = glob.refClients.find(d => d.uuid== value);  
      if (selectedelement && selectedelement.cities && selectedelement.cities.length > 0) {
        for (const item of selectedelement.cities) {
          city = {
            city: item.name,
            city_uuid: item.uuid,
            agent: item.contact,
            address: null,
            customer: selectedelement.uuid
          }
          cities.push(city);
        }
      }
      // if(selectedelement!=undefined && selectedelement.sites.length>1){
      //   for (const site of selectedelement.sites) {
      //     city = {
      //       city:site.city,
      //       uuid:site.uuid,
      //       agent:site.contact,
      //       address:null,
      //       customer:site.customer
      //     }
      //     cities.push(city);
          
          
      //   } 
      //   glob.citiesClient = cities;       
      // }else if(selectedelement.sites.length==1) {  
      //   var cityCustomer="";
      //   if(selectedelement.sites[0].city_uuid!=undefined && selectedelement.sites[0].city_uuid!=null){
      //     cityCustomer =selectedelement.sites[0].city_uuid;
      //   }else {
      //     cityCustomer =selectedelement.sites[0].uuid;
      //   }         
      //   city = {
      //     city:selectedelement.sites[0].city,
      //     uuid:cityCustomer,
      //     address:null,
      //     customer:selectedelement.sites[0].uuid
      //   }        
      //   cities.push(city);
        
      //   glob.citiesClient = cities;
      // }
      if(cities.length>0){
        $("#citiesSelect").prop("disabled", false);
        glob.citiesClient = cities;
      }else {
        $("#citiesSelect").prop("disabled", true);
      }

      
      
      glob.newVisitForm.controls['sector_uuid'].setValue(selectedelement.sector);

      // if($("#sectorsSelect").val()==""){
      //   glob.newVisitForm.controls['sector_uuid'].setValue(selectedelement.sector);
      // }
    });
    $('#citiesSelect').change(function(){
      var value = $(this).val();
      var elements = glob.citiesClient.find(d => d.city_uuid== value);
      glob.agent = elements?.agent;
      glob.address = elements?.address;
      glob.customer = elements?.customer;
      var selectedelement = glob.refClients.find(d => d.uuid== elements?.customer);
      glob.updateSitesForCity(selectedelement, value);
    });
    $(document).on('change', '#siteSelect', function(){
      var value = $(this).val();
      var selectedSite = glob.sitesOfCity.find((s:any) => s.uuid == value);
      glob.address = selectedSite?.address ?? glob.address;
    });
    $('#customer_cities').change(function() {
      var value = $(this).val();
      var cityName = $(this).find("option:selected").text();
    
      // Check if the city name already exists in the glob.cities array
      var existingCity = glob.cities.find((city) => city.name === cityName);
    
      // If the city name exists, update its UUID
      if (existingCity) {
        existingCity.uuid = value;
      } else {
        // If the city name doesn't exist, add a new city to the glob.cities array
        var city = {
          name: cityName,
          uuid: value
        };
        glob.cities.push(city);
    
        setTimeout(function() {
          $('#customer_cities').val("");
        }, 500);
      }
    
      // Update the 'city' form control's required attribute based on the cities array
      const cityFormControl = $('#customer_cities')[0] as HTMLSelectElement;
      cityFormControl.required = glob.cities.length === 0;
    
      // Update the validity of the 'city' form control
      cityFormControl.setCustomValidity(cityFormControl.validity.valid ? '' : 'Please select a city.');
    });    

    this.commercialsToAffect();
    this.getSectors();
    this.getPublicActions();
    this.getAllCustomizedActions();
    this.getIndicatorsClassesCustomers();
    this.loadCss("../assets/css/design.css");
    this.getCommercials();

    //add new customer
    this.newCustomerForm = this.fb.group({
      'social': ['', Validators.required],
      'sector' : ['', Validators.required],
      'agent' : [''],
      'email' : [''],
      'city' : ['', Validators.required],
      'zip' : [''],
      'address' : [''],
      'phone' : ['', [phoneNumberValidator()]],
      'skype' : [''],
      'class' : [''],
      'commercial': ['']
    });
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
    }
    this.getCities();

  }
  removeCity(city: any) {
    const cityIndex = this.cities.findIndex((c: any) => c.uuid === city.uuid);
    if (cityIndex !== -1) {
      const cityToRemove = this.cities.splice(cityIndex, 1)[0];
    }
  }
  getCommercials() {
    this.commercialsSubscriptions = this.teamService.getCommercials().subscribe(
      (resp: ServiceResponse) => {
        if(resp.code == "b1f37eec383fcada527079602ac178b3"){
          this.commercials = resp.commercials;
        }
      },
      (err: any) => {
        console.log(err);
        
      }
    );
  }

  initForms(){
    this.modifyactionForm = this.fb.group({
      'action_label': ['', Validators.required],
      'action_type' : ['', Validators.required] 
    }); 
    this.newactionForm = this.fb.group({
      'action_label': ['', Validators.required ],
      'action_type' : ['', Validators.required] 
    });
    this.newVisitForm = this.fb.group({
      'sector_uuid': ['', Validators.required],
      'customer_uuid' : ['', Validators.required],
      'commercial_uuid':['', Validators.required],
      'city_uuid':['', Validators.required],
      'site_uuid':[''],
      'goal':['', Validators.required],
      'action_label': [''],
      'action_uuid': [''],
      // MF-1881 — 1 à 5 sujets. minLength / maxLength s'appliquent à un tableau comme à
      // une chaîne : ils contrôlent ici le nombre d'éléments sélectionnés.
      'topic_uuid': [[] as string[], [Validators.required, Validators.minLength(1), Validators.maxLength(MAX_TOPICS)] ],
      'planned_date':['']
    });
    this.newVisitForm.controls['sector_uuid'].setValue("", {onlySelf: true});
    this.newVisitForm.controls['customer_uuid'].setValue("", {onlySelf: true});
    this.newVisitForm.controls['commercial_uuid'].setValue("", {onlySelf: true});
    this.newVisitForm.controls['city_uuid'].setValue("", {onlySelf: true});
    this.newVisitForm.controls['action_uuid'].setValue("", {onlySelf: true});
    // MF-1881 — un tableau vide, pas une chaîne vide : le contrôle porte une liste.
    this.newVisitForm.controls['topic_uuid'].setValue([], {onlySelf: true});
    this.topicsSelected = []; // MF-1881 — vide aussi les badges
  }

  removeSelectedAction(list:any[],value:any){
    let index;
      index = list.findIndex(d => d=== value); //find index in your array
      list=this.actionsSelected;
      list.splice(index, 1);
      
    //remove element from array
    if(this.actionsSelected.length>0){
      this.actionNotAssigned = false;
    }else {
      if($('#datePlanned').val() != "" && $('#datePlanned').val() != null){
        setTimeout(()=>{
          $("#noActionsSelected").css({"color":"red"});
        }, 800);
        this.actionNotAssigned = true;
      }else {
        this.actionNotAssigned = false;
      }
    }
  }
  
  actionToEdit(action:any){
    this.actionEdit=action;
  }

  getCities(){
    this.newCustomerForm.controls.city.setValue("");
    this.customersService.getRefCities();
    this.customersService.refCitiesSubject.subscribe(
      ( data: any ) => {
        if(data.code=="9d0907561104ccc6b9d188f036bd358c"){
          this.refCities = data.cities;
        }
      },
    )  
  }
  
  newAction(){
    const ActionFormValue = this.newVisitForm.value;
    if(ActionFormValue.action_label != null && ActionFormValue.action_label !=""
    && ActionFormValue.action_label !=" "){
    let index = this.actionsSelected.findIndex(d => d.action_description == ActionFormValue.action_label);      
    if(index<0){

      this.action = {
        action_description :ActionFormValue.action_label,
        action_type:"c"
      };
    
      this.actionsSelected.push(this.action);
    }
  }
    // if(this.action.action_type=="p"){
    //   this.publicActions.push(this.action);
    // }else {
    // var customized = {
    //   action_label :ActionFormValue.action_label,
    //   action_type:ActionFormValue.action_type,
    //   state:"new"
    // }
    // this.customizedActions.push(customized);
    // $(".customizedActions").animate({ scrollTop: $(".customizedActions") }, 500);
  }
  messageResponse:any="";
  saveVisite(typeSave:any) {
    var valuesNewVisitForm = this.newVisitForm.value;
    this.loadingAddingVisit = true;
    // if(this.newVisitForm.valid){
          this.newVisitRequest = {
            sector_uuid:valuesNewVisitForm.sector_uuid,
            customer_uuid:valuesNewVisitForm.customer_uuid,
            city_uuid:valuesNewVisitForm.city_uuid,
            site_uuid:valuesNewVisitForm.site_uuid,
            commercial_uuid:valuesNewVisitForm.commercial_uuid,
            planned_date:new Date(valuesNewVisitForm.planned_date),
            // MF-1881 — le back attend maintenant une liste nommée topics.
            topics: this.selectedTopicUuids(),
            goal:valuesNewVisitForm.goal,
            actions: this.actionsSelected
          };                    
          this.visitService.newVisitRequest = this.newVisitRequest;
          this.visitService.newVisit();
          this.newVisitRequest=this.visitService.newVisitSubject.subscribe(
            ( data: any ) => {
              if(typeSave=="planned"){
                this.type_creation = "planifiée";
              }else {
                this.type_creation = "créée"
              }
              if(data.code =="1449d22d939ee0fcd8679ce2a42546df"){
                this.newVisitForm.reset();
                $("#successSave").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  // Navigate to the visite page with the newly created visite's uuid
                  const newCustomerUuid = data.visit;
                  const customerPageUrl = 'visite/detail/it;cr=' + newCustomerUuid;
                  this.router.navigateByUrl(customerPageUrl);
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#successSave").hide();
                }, 2000);
                this.newVisitForm.controls['sector_uuid'].setValue("", {onlySelf: true});
                this.newVisitForm.controls['customer_uuid'].setValue("", {onlySelf: true});
                this.newVisitForm.controls['commercial_uuid'].setValue("", {onlySelf: true});
                this.newVisitForm.controls['city_uuid'].setValue("", {onlySelf: true});
                // MF-1881 — vide aussi les badges après un enregistrement réussi
                this.newVisitForm.controls['topic_uuid'].setValue([], {onlySelf: true});
                this.topicsSelected = [];
                this.newVisitForm.controls['action_uuid'].setValue("", {onlySelf: true});
                this.actionsSelected = [];
                this.getIndicatorsClassesCustomers();
                this.agent="- - -";
                this.address = "- - -";
              }else {
                // MF-1881 — le back distingue maintenant trois causes de refus, là où il
                // renvoyait un seul code pour « objectif ou sujet vide » (critère 2).
                // L'utilisateur voit lequel des deux champs est en faute.
                if(data.code == "9c8f1eb205b77511d8c9a1da9f664e97"){          // VIS003
                  this.messageErreurVisite = "L'objectif de la visite est obligatoire.";
                }else if(data.code == "87c8a2fea5b3ad2a4d553169316f52d7"){    // VIS004
                  this.messageErreurVisite = "Sélectionnez entre 1 et " + this.maxTopics + " sujets pour cette visite.";
                }else if(data.code == "80c5d233c0a09d7ecfa588d7145b233e"){    // VIS005
                  this.messageErreurVisite = "Un des sujets sélectionnés est introuvable ou n'appartient pas à votre société.";
                }else {
                  this.messageErreurVisite = "";
                }
                $("#error").show();
                $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#error").hide();
                }, 8000);
              }
              this.messageResponse = data.message;
              this.loadingAddingVisit = false;
              // this.newVisitForm.reset();
            },
          )
    // }
    $("html, body").animate({ scrollTop: 0 }, 500);
    
  };
  commercialsToAffect(){
    this.visitService.getCommercialsToAffect();
    this.visitService.commercialsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="b1f37eec383fcada527079602ac178b3"){
          this.loadingCommercials=false;
          this.ourTeam = data.commercials;
        }
        this.loadingCommercials=false;
      },
    )  
  }
  getSectors(){
    this.msSector.getSectors(this.token);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.refSectors = data.sectors;
        }
      },
    )  
  }
  getCustomers(sector:any){
    this.visitService.getCustomersSector(sector);
    this.visitService.customersSubject.subscribe(
      ( data: any ) => {
        if(data.code=="a899d2fac857262bd6a142d04b59f355"){
          this.clientsOfSector = data.customers;
          this.refClients = data.customers;
          if(data.customers.length>0){
            $("#clientSelect").prop("disabled", false);
          }else {
            $("#clientSelect").prop("disabled", true);
          }
          this.loadingCustomers =false;
          $("#citiesSelect").prop("disabled", true);
        }else {
          this.loadingCustomers =false;
          $("#clientSelect").prop("disabled", true);
        }
        this.loadingCommercials=false;
      },
    )  
  }
  getPublicActions(){
    this.visitService.getPublicActions();
    this.visitService.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.publicActions = data.actions;
          this.publicActions = this.publicActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
        }
      },
    )  
  }

  affectCustomizeAction(action:any){
    action = {
      action_description :action.action_label,
      action_type:action.action_type,
      action_uuid:action.action_uuid
    };
    this.actionsSelected.push(action)    
  }
  
  getAllCustomizedActions(){
    this.loadingCustomizedActions = true;
    this.visitService.getAllCustomizedActions();
    this.visitService.customActionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.customizedActions = data.actions;
          this.loadingCustomizedActions = false;
          this.customizedActions = this.customizedActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
          this.customizedActions = this.customizedActions.filter((v,i,a)=>a.findIndex(el=>(el.action_label===v.action_label))===i);
        }
        this.loadingCustomizedActions = false;
      },
    )  
  }
  Newaction(){
    var formvalues = this.newactionForm.value;
    if(this.newactionForm.valid){
      this.newactionRequest = {
        action_label :formvalues.action_label,
        action_type:formvalues.action_type,
        customer:formvalues.customer
      }
      this.newactionServiceService.newactionRequest = this.newactionRequest;
      this.newactionServiceService.getNewaction();
      this.newactionServiceService.newactionSubject.subscribe(
      ( data: any ) => {
        if(data.code =="58e325bd14a8c619427cc77656e88a60"){
          this.action = {
            action :data.action.action_label,
            uuid:data.action.action_uuid

          };

          this.actionsSelected.push(this.action.action);
          if(data.action.action_type == "4c9184f37cff01bcdc32dc486ec36961"){
            this.publicActions.push(data.action);
          }else{
            this.customizedActions.push(data.action);
          }
        }
      },)
    }
  }
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  
  modifyactionForm!: FormGroup;
  modifyactionRequest:any;
  visit:any;
  supprimeraction:any;
  Modifyaction(){
    var formvalues = this.modifyactionForm.value;
    if(this.modifyactionForm.valid){
      this.modifyactionRequest = {
        action_label :formvalues.action_label,
        action_type:formvalues.action_type,
      }
      this.newactionServiceService.modifyactionRequest = this.modifyactionRequest;
      this.newactionServiceService.getModifyaction(this.actionEdit.action_uuid);
      this.newactionServiceService.modifyactionSubject.subscribe(
      ( data: any ) => {  
        if(data.code =="4a7666e56245c35ffed4081a91ae730b"){
          this.action = {
            action :data.action.action_label,
            uuid:data.action.action_uuid,
          };
        }
        var index = this.customizedActions.indexOf(this.actionEdit);
        
        if (index !== -1) {
          this.getAllCustomizedActions()
         }
      },)
    }
  }
  Deleteaction(id:any){
    this.newactionServiceService.getDeleteaction(id);
    this.newactionServiceService.deleteactionSubject.subscribe(
      ( data: any ) => {
        if(data.code=="114c891a387eb63709491247e20afed3"){
          this.getAllCustomizedActions()
        }
      },
    )
  }
  getsupprimeraction(action:any){
    this.supprimeraction = action;
  }
  topics:any;

  // ------------------------------------------------------------------------------------------
  // MF-1881 — saisie des sujets (1 à 5), en badges comme les actions.
  // ------------------------------------------------------------------------------------------

  /** Borne haute, exposée au gabarit pour le compteur « n / 5 ». */
  readonly maxTopics = MAX_TOPICS;

  /** MF-1881 — message précis affiché sous l'alerte d'erreur, vide si la cause est autre. */
  messageErreurVisite: string = "";

  /**
   * MF-1881 — les sujets choisis, sur le même principe que `actionsSelected`.
   *
   * La saisie reprend le motif déjà en place pour les actions dans ce formulaire : une liste
   * déroulante SIMPLE, et chaque sujet choisi s'ajoute en badge sous le champ, retirable par sa
   * croix. Pas de `<select multiple>` : il obligerait l'utilisateur à maintenir Ctrl, ne
   * montrerait pas ce qui est choisi une fois la liste refermée, et jurerait avec le reste de
   * l'écran.
   *
   * Chaque élément a la forme { uuid, topic }, comme les entrées du référentiel.
   */
  topicsSelected: any[] = [];

  /** Les identifiants choisis, dans l'ordre d'ajout. */
  selectedTopicUuids(): string[] {
    return this.topicsSelected.map(t => t.uuid).filter((v: any) => !!v);
  }

  /** Nombre de sujets choisis, pour le compteur du gabarit. */
  selectedTopicsCount(): number {
    return this.topicsSelected.length;
  }

  /** Vrai quand la borne haute est atteinte : la liste déroulante se grise alors entièrement. */
  topicsLimitReached(): boolean {
    return this.topicsSelected.length >= MAX_TOPICS;
  }

  /**
   * MF-1881 — ajout d'un sujet depuis la liste déroulante, en badge sous le champ.
   *
   * Même comportement que le gestionnaire des actions : un sujet déjà choisi n'est pas ajouté
   * deux fois, et la liste se remet sur son option vide après l'ajout pour qu'on puisse
   * enchaîner les sélections.
   */
  addSelectedTopic(event: any): void {
    const select = event.target as HTMLSelectElement;
    const uuid = select.value;
    if (!uuid) { return; }

    if (this.topicsSelected.length >= MAX_TOPICS) {
      select.value = "";
      return;
    }

    const already = this.topicsSelected.findIndex(t => t.uuid === uuid) >= 0;
    if (!already) {
      const ref = (this.topics || []).find((t: any) => t.uuid === uuid);
      if (ref) {
        this.topicsSelected.push({ uuid: ref.uuid, topic: ref.topic });
        this.syncTopicControl();
      }
    }
    select.value = "";
  }

  /** MF-1881 — retrait d'un sujet par la croix de son badge. */
  removeSelectedTopic(topic: any): void {
    const index = this.topicsSelected.findIndex(t => t.uuid === topic.uuid);
    if (index >= 0) {
      this.topicsSelected.splice(index, 1);
      this.syncTopicControl();
    }
  }

  /** MF-1881 — vide la sélection, appelé partout où le formulaire est réinitialisé. */
  resetSelectedTopics(): void {
    this.topicsSelected = [];
    this.syncTopicControl();
  }

  /**
   * MF-1881 — recopie la sélection dans le contrôle `topic_uuid`.
   *
   * Le contrôle n'est plus lié à un champ du gabarit, mais il reste dans le formulaire : c'est
   * lui qui porte `Validators.required`, donc ce qui rend `newVisitForm.valid` faux tant
   * qu'aucun sujet n'est choisi. Angular considère un tableau vide comme une valeur manquante.
   */
  private syncTopicControl(): void {
    this.newVisitForm.controls['topic_uuid'].setValue(this.selectedTopicUuids());
    this.newVisitForm.controls['topic_uuid'].markAsTouched();
    this.newVisitForm.updateValueAndValidity();
  }

  /** Vrai quand plus de 5 sujets sont choisis, pour le message d'erreur du gabarit. */
  get hasTooManyTopics(): boolean {
    return this.selectedTopicsCount() > MAX_TOPICS;
  }

  Topic(){
    this.visitService.getTopic();
    this.visitService.topicSubject.subscribe(
      ( data: any ) => {
        if(data.code=="d9cc2e7dc2cf71242be86ab1ad241752"){
          this.topics = data.topics;
        }
      },
    )  
  }
  //SMART SUGGESTIONS 
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    node.charset = "utf-8";
    document.getElementsByTagName("head")[0].appendChild(node);
  }
  public loadCss(css:string) {
    let node = document.createElement("link");
    node.href = css;
    node.rel = "stylesheet";
    node.type = "text/css";
    node.media="all";
    document.getElementsByTagName("head")[0].appendChild(node);
  }
  classesIndicators!:any[];
  getIndicatorsClassesCustomers(){
    this.customersService.getIndicatorsClassesCustomers();
    this.customersService.customClassesIndicatorSubject.subscribe(
      ( data: any ) => {
        if(data.code=="0ef2434c1eb1e67d8135a655882a9628"){
          this.classesIndicators = data.classes;
        }
      },
    )  
  }
  customersToVisit:any[]=[];
  selectedClassModal:any;
  selectCustomersToVisit(classe:any){
    this.customersToVisit = classe.cutsomers;
    this.selectedClassModal = classe.classe;
    $('.icon_click_here').delay(300).fadeIn(2000);  
    setTimeout(()=>{
      $('.icon_click_here').delay(300).fadeOut(2000);
    }, 3000);
  }
  getCustomersToVisit(){
    $('.icon_click_here').delay(300).fadeIn(2000);  
    setTimeout(()=>{
      // $('.icon_click_here').delay(300).fadeOut(2000);
    }, 3000);
  }
  getAllCustomers(){
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        var newArrayAllCustomers:any[] = [];
        for(let cust of data.customers){
          var sites:any[]=[];
          var site:any = {
            city:cust.customer_city,
            uuid:cust?.city,
            customer:cust.customer,
            agent:null,
            address:null
          }
          sites.push(site)
          var customer = {
            rs_customer:cust.customer_rs,
            cities:cust.customer_cities,
            uuid:cust.customer,
            sites:sites,
            customerSites:cust.sites,
            sector:cust.sector
          }
          newArrayAllCustomers.push(customer);
        }
        setTimeout(()=>{
          this.refClients = newArrayAllCustomers;
          this.loadingCustomers =false;
          this.clientsOfSector = newArrayAllCustomers;
        }, 1000);
      },
    )  
  }
  updateSitesForCity(selectedelement:any, cityUuid:any){
    const matchingSites = (selectedelement?.customerSites || []).filter((s:any) => s.city_uuid == cityUuid);
    this.sitesOfCity = matchingSites;
    if(matchingSites.length == 1){
      this.newVisitForm.controls['site_uuid'].setValue(matchingSites[0].uuid, {onlySelf: true});
      this.address = matchingSites[0].address;
    } else {
      this.newVisitForm.controls['site_uuid'].setValue("", {onlySelf: true});
    }
  }
  select(uuid:any,customer:any){
    this.newVisitForm.controls['customer_uuid'].setValue(uuid);
    var city=null;
      this.address = "- - -";
      var cities = [];
      this.sitesOfCity = [];
      this.newVisitForm.controls['site_uuid'].setValue("", {onlySelf: true});
      var selectedelement = this.refClients.find(d => d.uuid== uuid);
      this.newVisitForm.controls['sector_uuid'].setValue(selectedelement.sector);
      if(selectedelement.sites.length>1){
        for (const site of selectedelement.sites) {
          city = {
            city:site.city,
            uuid:site.city_uuid,
            address:site.address,
            customer:site.customer
          }
          cities.push(city);
          this.citiesClient = cities;
        }
        
        $('#citiesSelect').addClass("clignote_selected_customer");
        setTimeout(()=>{
          $('#citiesSelect').removeClass("clignote_selected_customer");
        }, 3000);
      }else if(selectedelement.sites.length==1) {      
        city = {
          city:selectedelement.sites[0].city,
          uuid:selectedelement.sites[0].uuid,
          address:selectedelement.sites[0].address,
          customer:selectedelement.uuid
        }
        cities.push(city);
        this.newVisitForm.controls['city_uuid'].setValue(selectedelement.sites[0].uuid);
        this.updateSitesForCity(selectedelement, selectedelement.sites[0].uuid);
        this.citiesClient = cities;
        $('#topicSelect').addClass("clignote_selected_customer");
        setTimeout(()=>{
          $('#topicSelect').removeClass("clignote_selected_customer");
        }, 3000);
      }else {
        city = {
          city:selectedelement.city,
          uuid:selectedelement.city_uuid,
          address:selectedelement.address,
          customer:selectedelement.uuid
        }
        cities.push(city);
        this.citiesClient = cities;
      }
      
      if(cities.length>0){
        $("#citiesSelect").prop("disabled", false);
        (<any>$('#suggestions')).modal('hide');
        
        // glob.citiesClient = cities;
      }else {
        $("#citiesSelect").prop("disabled", true);
      }
  }

  addNewCustomer(){
    var valuesNewCustomerForm = this.newCustomerForm.value;
    this.loadingAddingCustomer = true;
    if(this.newCustomerForm.valid){
          this.newCustomerRequest = {
            social_reason:valuesNewCustomerForm.social,
            customer_sector:valuesNewCustomerForm.sector,
            represented_by:valuesNewCustomerForm.agent,
            customer_email:valuesNewCustomerForm.email,
            customer_cities:this.cities,
            customer_zip:valuesNewCustomerForm.zip,
            customer_address:valuesNewCustomerForm.address,
            customer_phone: valuesNewCustomerForm.phone,
            customer_skype: valuesNewCustomerForm.skype,
            customer_class: valuesNewCustomerForm.class,
            customerCommercial: valuesNewCustomerForm.commercial
          };
    }
    this.customersService.newCustomerRequest = this.newCustomerRequest;
          this.customersService.newCustomer();
          this.newCustomerRequest=this.customersService.newCustomerSubject.subscribe(
            ( data: any ) => {
              $("html, body").animate({ scrollTop: 0 }, 500);
              if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
                this.loadingAddingCustomer = false;
                this.newCustomerForm.reset();
                this.cities =[];
                let cust = data.customer
                var sites:any[]=[];
                var site:any = {
                  city:cust.customer_city,
                  uuid:cust.city,
                  customer:cust.customer
                }
                sites.push(site)
                var customer = {
                  rs_customer:cust.customer_rs,
                  city_uuid:cust.customer_city,
                  uuid:cust.customer,
                  sites:sites,
                  sector:cust.sector
                }
                this.refClients.push(customer);

                this.newVisitForm.get('customer_uuid')?.setValue(customer.uuid);
                this.newVisitForm.controls['sector_uuid'].setValue(customer.sector);
                this.newCustomerForm.controls['commercial'].setValue("", {onlySelf: true});


                var cities = [];
                let city = {
                  city:site.city,
                  uuid:site.uuid,
                  agent:site.contact,
                  address:null,
                  customer:site.customer
                }
                cities.push(city);
                this.citiesClient = cities;
                this.newVisitForm.get('city_uuid')?.setValue(city.uuid);
                $("#citiesSelect").prop("disabled", false);

                this.agent = city.agent;
                this.address = city.address;
                this.customer = city.customer;
                
                
                this.newCustomerForm.controls['sector'].setValue("", {onlySelf: true});
                this.newCustomerForm.controls['city'].setValue("", {onlySelf: true});
                $("#customer_added").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#customer_added").hide();
                }, 8000);
                // this.allCustomers.push(data.customer);
              } else if (data.code=="06c61e9f990cce9353c3064f99f6ec42"){
                this.addError ="Client existe dèja"; 
                this.loadingAddingCustomer = false;
                $("#customer_not_added").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#customer_not_added").hide();
                }, 8000)
              } else {
                this.addError ="Client non ajouté"; 

                this.loadingAddingCustomer = false;
                $("#customer_not_added").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#customer_not_added").hide();
                }, 8000);
              }
            },
          )
  }

  ngOnDestroy(): void{
    this.commercialsSubscriptions?.unsubscribe();
  }

}